import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { roleManagementApi } from "apis";
import CommonPopup from "components/common/CommonPopup";
import CustomTable, { CustomTableColumn } from "components/common/CustomTable";
import { EPath } from "constants/path";
import { GetRoleAssignedUserDto } from "libs/cellera-sdk";
import { useState } from "react";
import { useNavigate } from "react-router";

export interface AssignToModalProps {
  open: boolean;
  onClose: () => void;
  roleId: string;
}

export const AssignToModal = ({
  open,
  onClose,
  roleId,
}: AssignToModalProps) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { data, isLoading } = useQuery({
    queryKey: ["assign-to", roleId],
    queryFn: () => roleManagementApi.getRoleAssignments({ id: roleId }),
  });

  const columns: CustomTableColumn<GetRoleAssignedUserDto>[] = [
    {
      id: "name",
      label: "Name",
      getValue: (row) => row.name,
      sortable: true,
      sortAccessor: (row) => row.name,
    },
    {
      id: "email",
      label: "Email",
      getValue: (row) => row.email,
      sortable: true,
      sortAccessor: (row) => row.email,
    },
    {
      id: "phoneNumber",
      label: "Phone Number",
      getValue: (row) => row.phoneNumber,
      sortable: true,
      sortAccessor: (row) => row.phoneNumber,
    },
  ];

  const handlePageChange = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClickRow = (row: GetRoleAssignedUserDto) => {
    navigate(EPath.PRACTICE_DETAIL.replace(":practiceId", row.id));
  };

  return (
    <CommonPopup open={open} onClose={onClose} title="Assign To">
      <Box sx={{ width: "100%", minHeight: 400 }}>
        <CustomTable
          data={data}
          columns={columns}
          totalCount={data?.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          isLoading={isLoading}
          loadingMessage="Loading role assignments..."
          emptyStateContent={
            <Box sx={{ textAlign: "center", py: 4 }}>
              No users assigned to this role
            </Box>
          }
          minHeight={300}
          onClickRow={handleClickRow}
        />
      </Box>
    </CommonPopup>
  );
};
